import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AuxiliaryPump from "../components/auxiliary-Pump";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import { ErrorToast } from "../../../../widgets/AppToast";

const AuxilaryPumpLog = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [pump_Data, set_Pump_Data] = useState([]);

  const GET_SHIP_PUMP_LISTS = () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ship_pump_details_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_Pump_Data(res?.response_data);
        } else {
          ErrorToast("Error message", res?.message);
        }
        set_loader(false);
      });
    } catch (error) {
      set_loader(false);
      console.error("Error Pump list:", error);
    }
  };

  useEffect(() => {
    GET_SHIP_PUMP_LISTS();
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {pump_Data?.length > 0 ? (
              <>
                {pump_Data?.map((_items) => (
                  <>
                    <AuxiliaryPump eng_log_basic_id={eng_log_basic_id} _items={_items} />
                  </>
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AuxilaryPumpLog;
